// extracted by mini-css-extract-plugin
module.exports = {"sb__heading":"Scoreboard_sb__heading__2Wree","sb__buttons":"Scoreboard_sb__buttons__2Rwzh","sb__sound":"Scoreboard_sb__sound__3Immw","hide":"Scoreboard_hide__1ZjR1"};